import React, {useEffect, useMemo, useState} from "react";
import { Button, Icon, Input, Select, Table, TableHeader, TableBody, TableRow, TableHeaderCell, TableCell } from "semantic-ui-react";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";
import DimmerLoader from "../../../components/DimmerLoader/DimmerLoader";
import UsersCRUDForm from "./UsersCRUD.form";
import {useAppDispatch, useAppSelector} from "../../../hooks/hooks";
import {
    changePageSize,
    createModeHandler,
    deleteUser,
    getAllClients,
    getSingleUser,
    getUsers,
    setActivePage,
    setClientId
} from "./UsersCRUD.slice";
import IUser from "../../../common/interfaces/IUser";
import AppPagination from "../../../components/Pagination/AppPagination";
import './UsersCRUD.scss';

interface QueryParams {
    clientId?: number;
    role?: string;
    pageNum?: number;
    pageSize?: number;
    sort?: number;
    sortField?: string;
    search?: string;
}

const UsersCRUD = () => {
    const {allUsers, usersLoader, createMode, editMode, pagination, clientId, allowCRUD, allClients} = useAppSelector(state => state.UsersCRUD);
    const cms = useAppSelector(state => state.Auth.cms);
    const dispatch = useAppDispatch();
    const [searchWord, setSearchWord] = useState("");
    const [sortField, setSortField] = useState<string>('name');
    const [sortDirection, setSortDirection] = useState<'ascending' | 'descending'>('ascending');

    useEffect(() => {
        dispatch(getAllClients())
    }, [dispatch]);

    const clientOptions = useMemo(() => {
        //ToDo: Clients ����� ��� �������� User ��������������� �������� ��� �����-�������
        //const clients = allClients.map(client => {
        //    return {key: client.id, value: client.id, text: client.name}
        //})
        //clients.unshift({key: 0, value: 0, text: "Unselected"})
        const clients = { key: 0, value: 0, text: "Unselected" }
        return [clients]
    }, [allClients]);


    useEffect(() => {
        sortAndSearch()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchWord, sortField, sortDirection]);

    const sortAndSearch = () => {
        const params = {
            pageNum: searchWord ? 1 : pagination.activePage,
            pageSize: pagination.pageSize,
            search: searchWord.toLowerCase(),
            sortField,
            sort: sortDirection === "ascending" ? 0 : 1,
            clientId
        } as QueryParams
        dispatch(getUsers(createQueryString(params)))
    }
    const createQueryString = (params: QueryParams): string => {
        const queryEntries = Object.entries(params).filter(
            ([, value]) => value !== undefined && value !== null && value !== '' && value !== 0
        );

        const queryString = queryEntries
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
            .join('&');

        return queryString ? `?${queryString}` : '';
    };

    const getRoles = (roles: string[] | null) => {
        if (Array.isArray(roles)) {
            return !roles.length ? ["-"] : roles.join(', ');
        }
        return ["-"];
    }

    const onChangePager = (activePage: string | number | undefined) => {
        setActivePage(activePage)
        const params = {
            pageNum: activePage,
            pageSize: pagination.pageSize,
            search: searchWord.toLowerCase(),
            sortField,
            sort: sortDirection === "ascending" ? 0 : 1,
            clientId
        } as QueryParams
        dispatch(getUsers(createQueryString(params)))
    }

    const generateButtons = (user: IUser) => {
        if (cms['delete']) {
            return (
                <div className={"user-table-controls"}>
                    <DeleteModal id={user.id} titleModal={"Delete the user"}
                        confirmText={"Are you sure you want to delete this user?"}
                        deleteAction={() => dispatch(deleteUser(user.id))} />
                    <Icon name='pencil alternate' link size="small" color="grey" onClick={() => editUserHandler(user.id)} />
                </div>
            );
        }
    };

    const editUserHandler = (id: number) => dispatch(getSingleUser(id));

    const createUserHandler = () => dispatch(createModeHandler(true));

    const handleSort = (field: string) => {
        const direction = sortField === field && sortDirection === 'ascending' ? 'descending' : 'ascending';
        setSortField(field);
        setSortDirection(direction);
    };

    const onChangePageSize = (value: any) => {
        dispatch(changePageSize(value))
        const params = {
            pageNum: pagination.activePage,
            pageSize: value,
            search: searchWord.toLowerCase(),
            sortField,
            sort: sortDirection === "ascending" ? 0 : 1,
            clientId
        } as QueryParams
        dispatch(getUsers(createQueryString(params)))
    }

    const filterUserByClient = (client: any) => {
        const params = {
            pageNum: 1,
            pageSize: pagination.pageSize,
            search: searchWord.toLowerCase(),
            sortField,
            sort: sortDirection === "ascending" ? 0 : 1,
            clientId: client
        } as QueryParams
        dispatch(getUsers(createQueryString(params)))
        dispatch(setClientId(client))
    }

    return (
        <div className="cms-container-general">
            <div className="users-btn-wrapper">
                <div className={"users-inp-inner"}>
                    <Select options={clientOptions} value={clientId} placeholder='Select client'
                        onChange={(e, { value }) => {filterUserByClient(value)}} />
                </div>
                <Input icon='search' placeholder='Search...' onChange={(e) => setSearchWord(e.target.value)} />
                {allowCRUD &&
                    <Button disabled={usersLoader} className={'users-table'} color="blue" id="add_game" onClick={createUserHandler}>Add</Button>
                }
            </div>
            {allUsers?.length > 0 && !usersLoader &&
                <div className="cms-table-general">
              <Table sortable celled textAlign="center">
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell sorted={sortField === 'name' ? sortDirection : undefined} onClick={() => handleSort('name')}>
                                Name
                            </TableHeaderCell>
                            <TableHeaderCell>Role</TableHeaderCell>
                            <TableHeaderCell sorted={sortField === 'email' ? sortDirection : undefined} onClick={() => handleSort('email')}>
                                E-mail
                            </TableHeaderCell>
                            {allowCRUD &&
                                <TableHeaderCell />
                            }
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {allUsers.map((user: IUser) => {
                            return (
                                <TableRow key={user.id}>
                                    <TableCell>{user.name}</TableCell>
                                    <TableCell>{getRoles(user.roles!)}</TableCell>
                                    <TableCell>{user.email}</TableCell>
                                    {allowCRUD &&
                                        <TableCell>{generateButtons(user)}</TableCell>
                                    }
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
                </div>
            }
            {usersLoader &&
                <DimmerLoader />
            }
            {allUsers.length === 0 && <div className={"users-no-content"}>No users</div>}
            {createMode || editMode ? <UsersCRUDForm/> : null}
            {allUsers.length > 0 &&
                <AppPagination props={pagination} onChangePager={onChangePager} onChangePageSize={onChangePageSize} />
            }
        </div>
    );
}

export default UsersCRUD;
